import styled from 'styled-components';
import {dFlex, alignCenter, flexColumn, flexWrap} from '../../../../globalVariables/GlobalFlex';
import {wrapCheckbox} from '../../../../component/checkboxFormik/CheckboxFormik.css';
import {scrollbar, WHITE, DARK_GRAY} from '../../../../globalVariables/GlobalVariables';
import {header} from '../bottomPopup/BottomPopup.css';

export const popupContent = styled.div`
  background: ${WHITE};
  border-radius: 12px;
  padding: 25px 35px;
  ${scrollbar};
  width: 100%;
  ${dFlex};
  ${flexColumn};
  height: calc(100% - 190px);
  text-align: start;
`;

export const title = styled.h2`
  margin-inline-end: 8px;
  text-align: start;
`;

export const subTitle = styled.div`
  color: ${DARK_GRAY};
  margin-block-end: 24px;
  text-align: start;
  font-size: 16px;
`;

export const fields = styled.div`
  margin-block-end: 16px;
  text-align: start;
  ${dFlex};
  gap: 16px;
  ${flexWrap};
`;

export const inputWrapper = styled.div`
  flex: 1;
  min-width: 200px;
`;

export const checkBoxWrap = styled.div`
  ${dFlex};
  ${alignCenter};
  gap: 8px;
  margin-top: 8px;
  font-size: 15px;
  margin-block: 20px;
  ${wrapCheckbox}{
    width: max-content; 
    gap: 10px;
  }
`;

export const committeePopup = styled.div`
  ${header}{
    &::after{
      width : 500px;
    }
  }
`; 